import { render } from "./TabPlantDetailsPlotSOC.vue?vue&type=template&id=2956df25"
import script from "./TabPlantDetailsPlotSOC.vue?vue&type=script&lang=js"
export * from "./TabPlantDetailsPlotSOC.vue?vue&type=script&lang=js"

import "./TabPlantDetailsPlotSOC.vue?vue&type=style&index=0&id=2956df25&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__